import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

export const isNextCharacterText = (editor: BufferEditor): boolean => {
  if (!editor.selection) return false

  const nextChar = editor.api.string(
    editor.api.range(editor.selection, editor.api.after(editor.selection)),
  )

  return nextChar !== '' && !/\s/.test(nextChar)
}
